import { Column } from "components/table/Table";
import get from "lodash/get";
import React from "react";
import { Link } from "react-router-dom";
import { Meet } from "types";

const TeamCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const team = data;
  if (team.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if (data.row === "title") {
    return (
      <div style={style} className="table-cell-inner">
        <br />
        {get(team, "name")}
      </div>
    );
  } else {
    let link = `/meets/${get(meet, "_id")}/team/${encodeURIComponent(
      get(team, "team")
    )}`;
    if (team.gender) {
      const queryString = new URLSearchParams({
        gender: team.gender,
      }).toString();
      link = `${link}?${queryString}`;
    }
    return (
      <div style={style} className="ellipsis table-cell-inner">
        <Link to={link}>{get(team, "team")}</Link>
      </div>
    );
  }
};

export default TeamCell;
